export const PAGINATION_ELLIPSIS = "…" as const;

export type PaginationSlot = number | typeof PAGINATION_ELLIPSIS;

/**
 * Номера страниц для панели пагинации: первая, последняя, текущая с соседями,
 * остальное свёрнуто в многоточие. Без этого при 5000 заказах рисуется 250
 * кнопок и панель уезжает за экран.
 */
export function paginationRange(
  page: number,
  totalPages: number,
  siblings = 1,
): PaginationSlot[] {
  // 1 … 4 5 6 … 25 — максимум 7 слотов; если страниц не больше, показываем все.
  const maxSlots = siblings * 2 + 5;

  if (totalPages <= maxSlots) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const current = Math.min(Math.max(page, 1), totalPages);
  const from = Math.max(current - siblings, 2);
  const to = Math.min(current + siblings, totalPages - 1);

  const slots: PaginationSlot[] = [1];

  if (from > 2) slots.push(PAGINATION_ELLIPSIS);

  for (let p = from; p <= to; p++) slots.push(p);

  if (to < totalPages - 1) slots.push(PAGINATION_ELLIPSIS);

  slots.push(totalPages);

  return slots;
}
